import {
  Avatar,
  Box,
  Card,
  Icon,
  IconButton,
  MenuItem,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  useTheme,
} from '@mui/material';
import { Paragraph, Span } from '../../../components/Typography';
import { Link } from "react-router-dom";
import { MatxMenu } from "../../../components";
import React, { useState } from "react";
import { useTopSellingProduct } from '../../../requests/dashboard';
import useAuth from '../../../hooks/useAuth';

const CardHeader = styled(Box)(() => ({
  display: 'flex',
  paddingLeft: '24px',
  paddingRight: '24px',
  marginBottom: '12px',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const Title = styled('span')(() => ({
  fontSize: '1rem',
  fontWeight: '500',
  textTransform: 'capitalize',
}));

const ProductTable = styled(Table)(() => ({
  minWidth: 400,
  whiteSpace: 'pre',
  '& small': {
    width: 50,
    height: 15,
    borderRadius: 500,
    boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24)',
  },
  '& td': { borderBottom: 'none' },
  '& td:first-of-type': { paddingLeft: '16px !important' },
}));


const StyledItem = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  minWidth: 200,
  '& a': {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  },
  '& span': { marginRight: '10px', color: theme.palette.text.primary },
}));

const Small = styled('small')(({ bgcolor }) => ({
  width: 50,
  height: 15,
  color: '#fff',
  padding: '2px 8px',
  borderRadius: '4px',
  overflow: 'hidden',
  background: bgcolor,
  boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24)',
}));

const TopSellingTable = (
  // { top_Selling_prodiucts }
) => {
  const { palette } = useTheme();
  const bgError = palette.error.main;
  const bgPrimary = palette.primary.main || '#ddd';
  const bgSecondary = palette.secondary.main || '#ddd';


  const { data: topSellingProduct } = useTopSellingProduct();

  
  const user = useAuth();
  if (user?.user?.service_area_id) {
    return <></>
  }

  function shopName(vendor) {
    if (!vendor) return 'N/A';

    if (typeof vendor === 'object') {
      return vendor?.shop_name;
    }
    return `N/A`
  }


  

  return (
    <Card elevation={3} sx={{ pt: '20px', mb: 3 }}>
      <CardHeader>
        <Title>top selling products</Title>
      </CardHeader>

      <Box overflow="auto">
        <ProductTable>
          <TableHead>
            <TableRow>
              <TableCell sx={{ px: 3 }} colSpan={4}>
                Name
              </TableCell>
              <TableCell sx={{ px: 0 }} colSpan={2}>
                Seller
              </TableCell>
              <TableCell sx={{ px: 0 }} colSpan={2}>
                Price
              </TableCell>
              <TableCell sx={{ px: 0 }} colSpan={2}>
                Stock Status
              </TableCell>
              <TableCell sx={{ px: 0 }} colSpan={1}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {(topSellingProduct?.products || []).map((top_product, index) => (
              <TableRow key={index} hover>
                <TableCell colSpan={4} align="left" sx={{ px: 0, textTransform: 'capitalize' }}>
                  <Box display="flex" alignItems="center">
                    <Avatar src={(top_product?.images_new?.length > 0 ? top_product?.images_new[0]?.image : "")} />
                    <Paragraph sx={{ m: 0, ml: 4 }}>{top_product.product_title}</Paragraph>
                  </Box>
                </TableCell>

                <TableCell align="left" colSpan={2} sx={{ px: 0, textTransform: 'capitalize' }}>
                  {/* {top_product && top_product?.vendors[0]?.shop_name} */}
                  {shopName(top_product?.vendor)}
                </TableCell>

                <TableCell align="left" colSpan={2} sx={{ px: 0, textTransform: 'capitalize' }}>
                  ৳{top_product?.sale_price > 999 ? (top_product?.sale_price / 1000).toFixed(1) + 'k' : top_product?.sale_price}
                </TableCell>

                <TableCell sx={{ px: 0 }} align="left" colSpan={2}>
                  {top_product?.stock ? (
                    top_product?.stock < 20 ? (
                      <Small bgcolor={bgSecondary}>{top_product?.stock} available</Small>
                    ) : (
                      <Small bgcolor={bgPrimary}>in stock</Small>
                    )
                  ) : (
                    <Small bgcolor={bgError}>out of stock</Small>
                  )}
                </TableCell>

                <TableCell sx={{ px: 0 }} colSpan={1}>
                  <MatxMenu
                    menuButton={
                      <IconButton>
                        <Icon color="primary">edit</Icon>
                      </IconButton>
                    }>
                    <StyledItem>
                      <Link to={"/product/add/" + top_product.id}>
                        <Icon> edit </Icon>
                        <Span> Edit </Span>
                      </Link>
                    </StyledItem>

                    <StyledItem>
                      <Link to={"/product/detail/" + top_product.id}>
                        <Icon> remove_red_eye </Icon>
                        <Span> View </Span>
                      </Link>
                    </StyledItem>
                  </MatxMenu>
                </TableCell>


              </TableRow>
            ))}
          </TableBody>
        </ProductTable>
      </Box>
    </Card>
  );
};

export default TopSellingTable;
